import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import routes from '../routes/route';

export default {
  attributeName: 'appProvider',
  isDragable: false,
  canOpen: true,
  canEdit: true,
  canCreate: true,
  canRemove: true,
  editURL: routes.APP_PROVIDER_EDIT,
  emptyMessage: "You don't have V.T. Providers, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'providerImage',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Logo',
      helpText: 'Logo to identify the provider in the app.',
      placeholder: 'Poster URL...',
      canCreate: true,
      canEdit: true,
      fileType:['image/*'],
      exactWidth:'200px',
    },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Title of virtual ticket provider.',
      default: '',
      canEdit: true,
      canCreate: true,
      canFilter: true,
      canOrder: true,
    },
    {
      attributeName: 'uses',
      label: 'Uses',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      helpText: 'Number of uses per token.',
      default: 1,
      width: '10rem',
      canEdit: true,
      canCreate: true,
      canFilter: true,
      canOrder: true,
      exactWidth:'120px',
    },
    {
      attributeName: 'type',
      label: 'Type',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canEdit: false,
      canCreate: false,
      default: '',
      helpText: 'Type of virtual ticket provider.',
      canFilter: true,
      canOrder: true,
      exactWidth:'220px',

    },
  ],
};
